module.exports = __webpack_public_path__ + "img/HonestJohn-FullLogo-FullColour-NoBackground.2c0498e3.png";